<template>
  <el-dialog
    class="radish-dia"
    title="安排面试"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="候选人"> <el-input v-model="form['候选人']" disabled></el-input> </el-form-item>
      <el-form-item label="顾问"> <el-input v-model="form['顾问']" disabled></el-input> </el-form-item>
      <el-form-item label="面试时间">
        <el-date-picker v-model="form['面试时间']" type="datetime" placeholder="选择日期时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="联系人"> <el-input v-model="form['联系人']"></el-input> </el-form-item>
      <el-form-item label="联系电话"> <el-input v-model="form['联系电话']"></el-input> </el-form-item>
      <el-form-item label="面试地址">
        <el-autocomplete v-model="form['面试地址']" size="mini" :fetch-suggestions="fetchSuggestions"></el-autocomplete>
      </el-form-item>
      <el-form-item label="面试官"> <el-input v-model="form['面试官']"></el-input> </el-form-item>
      <el-form-item label="终面"> <el-switch v-model="form.isFinal"></el-switch> </el-form-item>
      <el-form-item label="备注"> <el-input v-model="form['备注']" type="textarea"></el-input> </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      form: {},
      addr: [],
      comId: '',
      submiting: false,
      rid: '',
      pid: '',
    }
  },
  methods: {
    show: async function({ type, row, pid, pro }) {
      this.rid = row.rid
      this.pid = pid
      if (type == 'edit') {
        const intRes = await app.service('radish').findInterview({ rid: this.rid, pid: this.pid })
        if (intRes.status === 'success') {
          if (intRes.data.length > 0) {
            this.form = intRes.data[0]
          } else {
            return this.$message.error('面试数据不存在')
          }
        } else {
          return this.$message.error(intRes.msg)
        }
      } else {
        const form = {
          isFinal: false,
        }
        form['顾问'] = app.user.account
        form['候选人'] = row['姓名']
        form.rid = row.rid
        form.pid = pid
        this.form = form
      }
      if (pro['客户公司']) {
        const com = await app.service('company').getCompany(pro['客户公司'])
        if (com.status == 200) {
          this.comId = com.result._id
          if (com.result['面试地址']) {
            this.addr = com.result['面试地址'] || []
          }
        }
      }
      this.dialogVisible = true
    },
    fetchSuggestions: function(qs, cb) {
      if (this.addr.length > 0) {
        const s = this.addr.map(item => ({ value: item['地址'] }))
        if (!qs) {
          cb(s)
        } else {
          cb(
            s.filter(c => c.value && c.value.toUpperCase().indexOf(qs.toUpperCase()) != -1),
          )
        }
      } else {
        cb([])
      }
    },
    handleConfirm: async function() {
      if (this.submiting) return this.$message('提交中，请勿重复提交')
      this.submiting = true
      const dt = JSON.parse(JSON.stringify(this.form))
      dt['面试时间'] = dateFormat(dt['面试时间'], 'yyyy-mm-dd HH:MM:ss')
      if (dt._id) {
        // 编辑
        const interId = dt._id
        const newDt = {
          候选人: dt.候选人,
          顾问: dt.顾问,
          面试时间: dt.面试时间,
          联系人: dt.联系人,
          联系电话: dt.联系电话,
          面试地址: dt.面试地址,
          面试官: dt.面试官,
          终面: dt.终面,
          备注: dt.备注,
        }
        const res = await app.service('radish').modifyInterview({ _id: interId, data: newDt, isEdit: true })
        if (res.status == 'success') {
          this.$message.success('修改成功')
        } else {
          this.$message.error(res.msg)
        }
        this.submiting = false
        this.dialogVisible = false
      } else {
        // 新增
        const res = await app.service('radish').addInterview(dt)
        if (res.status == 'success') {
          const address = this.addr.map(val => val.地址)
          const newAddr = dt['面试地址'] || ''
          const bannedKeyWords = ['微信', '电话']
          const hasKeyWords = bannedKeyWords.some(val => newAddr.includes(val))
          if (this.comId && newAddr && !hasKeyWords && !address.includes(newAddr)) {
            const newAddress = { cid: this.comId, 地址: dt['面试地址'], 备注: '' }
            const res = await app.service('company').addCompanyAddress(newAddress)
            if (res.status === 'success') this.addr = res.data
            // this.addr.push({ 地址: dt['面试地址'] })
            // let ad = JSON.parse(JSON.stringify(this.addr))
            // const cRes = await app.service('company').updateCompany({ company: { _id: this.comId, 面试地址: ad } })
          }
          this.onConfirm()
        }
        if (res.msg == '已经淘汰') {
          this.$confirm('候选人已经被淘汰不能面试，是否要重启面试?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              await this.uneliminate()
              this.submiting = false
              this.handleConfirm()
            })
            .catch(() => {
              this.submiting = false
              this.dialogVisible = false
            })
        } else {
          if (res.status == 'success') {
            this.$message.success(res.msg)
            this.onConfirm()
          } else {
            this.$message.info(res.msg)
          }
          this.submiting = false
          this.dialogVisible = false
        }
      }
    },
    uneliminate: async function() {
      const intRes = await app.service('radish').findInterview({ rid: this.rid, pid: this.pid })
      if (intRes.status === 'success') {
        const intvs = intRes.data.filter(i => i['结果'] === '淘汰')
        if (intvs.length > 0) {
          await app.service('radish').modifyInterview({ _id: intvs[0]._id, data: { 结果: '重启' } })
          this.$message.success('重启成功')
        }
      }
    },
  },
}
</script>
